/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DiscoverIcon = ({ width = 24, height = 24, hidden = false, title = 'Discover' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18 34.2c8.947 0 16.2-7.253 16.2-16.2S26.947 1.8 18 1.8 1.8 9.053 1.8 18 9.053 34.2 18 34.2Zm-7.532-24.05c.05 0 .1.008.147.024l11.183 3.593a.944.944 0 0 1 .607.602l3.569 10.824a.472.472 0 0 1-.582.6l-11.145-3.31a.943.943 0 0 1-.629-.614l-3.596-11.101a.472.472 0 0 1 .446-.618Z"
    />
    <path d="m15.508 20.562 5.008-4.896-7.36-2.366 2.352 7.262z" />
  </svg>`;
};
